export const getSignalPayload = async (registerId, entryId) => {
  // Fetch entry directly from the new register entries API
  const res = await fetch(
    `https://registers.poc.mrc.ai/api/registerentries/${entryId}`
  );

  if (!res.ok) {
    throw new Error(`Failed to fetch register entry: ${entryId}`);
  }

  const entry = await res.json();

  // Verify the entry belongs to the specified register
  if (entry.registerId !== registerId) {
    throw new Error(`Entry '${entryId}' does not belong to register '${registerId}'`);
  }

  const now = new Date().toISOString();

  return {
    _id: crypto.randomUUID(),
    transactionFunctionCode: "add",
    name: entry.name || "Unnamed Signal",
    type: entry.type || "standard-signal",
    payload: "", 
    data: [
      {
        id: crypto.randomUUID(),
        transactionFunctionCode: "add",
        type: entry.type || "",
        classCode: entry.classCode || "",
        scheduleId: entry.scheduleId || "",
        scheduleType: entry.scheduleType || "",
        objectId: entry.objectId || "",
        objectType: entry.objectType || "",
        objectClassCode: entry.objectClassCode || "",
        parentId: entry.parentId || "",
        parentType: entry.parentType || "",
        parentClassCode: entry.parentClassCode || "",
        metadataStandardCode: entry.metadataStandardCode || "",
        name: entry.name || "",
        description: entry.description || "",
        quantity: entry.quantity ?? 0,
        created: now,
        dateTime: now,
        references: entry.references || [],
        parties: entry.parties || [],
        addresses: entry.addresses || [],
        classifications: entry.classifications || [],
        amounts: entry.amounts || [],
        dateTimes: entry.dateTimes || [],
        text: entry.text || [],
        payload: entry.payload || "",
      },
    ],
  };
};
